'use strict';

import { BaseElement } from '../../interfaces/BaseElement';
import {isMobile} from "../../../settings";

export class RenderingLogo {
  #active = config.features.renderingBy?.active || false;
  #type = config.features.renderingBy?.type || '';

  constructor () {
    if (!this.active) return;

    const parent =
      isMobile
        ? document.querySelector('.aside__top__container')
        : document.querySelector('.aside__bottom__container')
    this.container = new BaseElement()
      .addClass('rendering-logo')
      .appendTo(parent);

    new BaseElement('span')
      .addClass('rendering-text')
      .innerHtml('renderings by ')
      .appendTo(this.container.DOMElement);

    this.logo = new BaseElement()
      .addClass('rendering-img')
      .appendTo(this.container.DOMElement);

    switch (this.#type) {
      case 'viewpoint':
        this.logo.DOMElement.style.backgroundImage = `url(../img/logo/viewpoint_logo.png)`;
        break;
      default:
        console.log('Default rendering logo case');
        break;
    }
  }

  get active() {
    return this.#active;
  }

}
